
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Capa_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 50 50","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M49.9 14.7c-.1-2.7-.5-4.5-1.2-6.1-.6-1.7-1.6-3.2-2.9-4.4-1.3-1.3-2.8-2.3-4.4-2.9C39.8.7 38 .3 35.3.1 32.6 0 31.8 0 25 0s-7.6 0-10.3.1c-2.7.2-4.5.6-6.1 1.2-1.6.6-3.1 1.6-4.4 2.9C2.9 5.4 1.9 7 1.3 8.6.7 10.2.3 12 .1 14.7 0 17.4 0 18.2 0 25s0 7.6.1 10.3c.1 2.7.5 4.5 1.2 6.1.6 1.7 1.6 3.2 2.9 4.4 1.3 1.3 2.8 2.3 4.4 2.9 1.6.6 3.4 1 6.1 1.2 2.7.1 3.5.1 10.3.1s7.6 0 10.3-.1c2.7-.1 4.5-.5 6.1-1.2 3.4-1.3 6-4 7.3-7.3.6-1.6 1-3.4 1.2-6.1.1-2.7.1-3.5.1-10.3s0-7.6-.1-10.3zm-4.5 20.4c-.1 2.4-.5 3.8-.9 4.6-.8 2.2-2.6 3.9-4.7 4.7-.9.3-2.2.8-4.6.9-2.6.1-3.4.1-10.1.1s-7.5 0-10.1-.1c-2.4-.1-3.8-.5-4.6-.9-1.1-.4-2.1-1-2.9-1.9-.8-.8-1.5-1.8-1.9-2.9-.3-.9-.8-2.2-.9-4.6-.1-2.5-.2-3.3-.2-10s0-7.5.1-10.1c.1-2.4.5-3.8.9-4.6.4-1.1 1-2.1 1.9-2.9.8-.8 1.8-1.5 2.9-1.9.9-.3 2.2-.8 4.6-.9 2.6-.1 3.4-.1 10.1-.1 6.7 0 7.5 0 10.1.1 2.4.1 3.8.5 4.6.9 1.1.4 2.1 1 2.9 1.9.8.8 1.5 1.8 1.9 2.9.3.9.8 2.2.9 4.6.1 2.6.1 3.4.1 10.1s0 7.5-.1 10.1z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M25 12.2c-7.1 0-12.8 5.8-12.8 12.8S17.9 37.9 25 37.9c7.1 0 12.8-5.8 12.8-12.8S32.1 12.2 25 12.2zm0 21.1c-4.6 0-8.3-3.7-8.3-8.3s3.7-8.3 8.3-8.3c4.6 0 8.3 3.7 8.3 8.3s-3.7 8.3-8.3 8.3zM41.4 11.7c0 1.7-1.3 3-3 3s-3-1.3-3-3 1.3-3 3-3c1.6 0 3 1.3 3 3z"}})])
          )
        }
      }
    